import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=c8ac9478&"
import script from "./Detail2.vue?vue&type=script&lang=js&"
export * from "./Detail2.vue?vue&type=script&lang=js&"
import style0 from "./Detail2.vue?vue&type=style&index=0&id=c8ac9478&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports